function parse(value) {
  const raw = String(value || '').trim();
  if (!raw) return null;
  const normalized = raw.includes(' ') && !raw.includes('T') ? raw.replace(' ', 'T') : raw;
  const d = new Date(normalized);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** "7 Oct 2026" (date only) or "7 Oct 2026, 4:48 pm" when the value has a time. */
export function fmtDate(value) {
  const d = parse(value);
  if (!d) return value ? String(value) : '—';
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(String(value).trim());
  return d.toLocaleString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...(dateOnly ? {} : { hour: 'numeric', minute: '2-digit' }),
  });
}

export function fmtTime(value) {
  const d = parse(value);
  return d ? d.toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit' }) : '—';
}

export function todayIso() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function isToday(value) {
  const d = parse(value);
  if (!d) return false;
  const now = new Date();
  return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
}
